module.exports = __webpack_public_path__ + "static/pincel_1-1e6927c2bc23be441370a066a5ccba05.jpg";